<template>
  <!-- 添加 -->
  <div class="add-node-btn-box">
    <div class="add-node-btn">
      <el-popover placement="right" trigger="click">
        <ul class="flow-action">
          <li class="flow-action-wrap" @click="handlerAddNode(sourceData, 1, branch)">{{ $t('work_rule_48') }}</li>
          <!--    v-if="(!sourceData.conditionList || !sourceData.conditionList.length) && sourceData.type !== 3" -->
          <li
            class="flow-action-wrap"
            @click="handlerAddNode(sourceData, 3, branch)"
            v-if="!sourceData.conditionList || !sourceData.conditionList.length"
          >
            {{ $t('work_rule_59') }}
          </li>
          <!-- 抄送人 -->
          <li class="flow-action-wrap" @click="handlerAddNode(sourceData, 2, branch)">{{ $t('734') }}</li>
        </ul>
        <button slot="reference" class="add-btn">
          <i class="el-icon-plus" />
        </button>
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sourceData: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Array | Object,
      default: () => []
    },
    branch: {
      type: Boolean,
      default: false
    }
  },
  inject: ['handlerAddNode']
}
</script>

<style lang="scss" scoped>
@import './node.scss';
</style>
